export const ordertodm = {
ConfirmationOrdersToDM: {
  title: "Confirmation Orders to DM Upload",
  description: "The Confirmation Orders to DM module enables seamless transition of Confirmation Orders (COs) from the order processing stage to the Deckle Matching workflow. It allows users to view, filter, validate, and upload COs while ensuring accurate and efficient order handoff for downstream operations.",

  features: [
    "View and filter COs based on configurable date ranges and key data fields.",
    "Analyse order details such as status, line items, billing and shipping parties, and item-level remarks.",
    "Upload validated orders directly into the Deckle Matching process through the integrated Upload to Optrim function.",
    "Export filtered CO lists for audit, reporting, or offline verification purposes."
  ],

  screens: [
    {
      name: "CO Upload Dashboard",
      purpose: "Main interface to view, filter, and process Confirmation Orders.",
      steps: [
        { title: "Step 1: Set CO Date Range", details: "Use the calendar icons on the top-right to select start and end dates. The grid will refresh showing COs within the selected date range." },
        { title: "Step 2: Filter Confirmation Orders (Optional)", details: "Apply column-level filters to narrow down COs by fields like CO No., Line No., Item Status, Bill To Party, Ship To Party, and Item Remarks." },
        { title: "Step 3: Review CO Details", details: "Scroll horizontally to check all order details, ensure ITEM STATUS is appropriate, and mandatory fields are populated. If grid is empty, check date range, remove filters, or confirm orders exist in backend." },
        { title: "Step 4: Upload to Deckle Matching", details: "Click 'Upload to Optrim'. The system validates selected orders, initiates transfer to Deckle Matching, and provides a notification on success or errors." },
        { title: "Download CO List", details: "Click the Download (⬇) icon to export the currently filtered COs as .xlsx or .csv for record-keeping or offline validation." }
      ],
      columnsDisplayed: [
        { column: "CO No.", description: "Unique confirmation order number." },
        { column: "Line No.", description: "Line item number." },
        { column: "Item Status", description: "Status such as Confirmed, Pending, or Cancelled." },
        { column: "CO Date", description: "Date of the confirmation order." },
        { column: "Bill To Party", description: "Customer responsible for payment." },
        { column: "Ship To Party", description: "Destination party." },
        { column: "Item Remarks", description: "Additional comments, if any." }
      ]
    }
  ],

  buttons: [
    { name: "⬆ Upload to Optrim", hint: "Validate and transfer selected COs to Deckle Matching." },
    { name: "⬇ Download", hint: "Export filtered COs to Excel or CSV." }
  ],

  bestPractices: [
    "Use accurate date filters to avoid missing relevant COs.",
    "Apply filters to focus only on orders ready for upload.",
    "Validate that all mandatory fields are filled correctly before uploading.",
    "Download CO lists for records or audits.",
    "Monitor status messages and resolve any upload issues promptly."
  ],

  troubleshooting: [
    { issue: "No data visible", solution: "Adjust date range or clear filters." },
    { issue: "Upload button inactive", solution: "Ensure valid COs are selected and visible." },
    { issue: "Upload fails", solution: "Check error messages and validate CO details." },
    { issue: "Download not working", solution: "Enable pop-ups/downloads in browser settings." }
  ]
}
};